import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PrimeNGConfig } from 'primeng/api';
import { MessageService } from 'primeng/api';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { allSchemes, Scheme } from '../../../shared/data/allSchemes';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { environment } from '../../../../environments/environment';
import { FileUpload } from 'primeng/fileupload';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../../editorconfig';
import { Subscription } from 'rxjs';
import { UploadService } from '../../../services/upload/upload.service';

@Component({
  selector: 'app-sotr',
  standalone: false,
  templateUrl: './sotr.component.html',
  styleUrl: './sotr.component.scss',
})
export class SotrComponent implements OnInit {
  @Output() routeConfig = new EventEmitter<{ isRouteConfig: boolean }>();
  @Input() proposalStep_id:any
  @Input() id: any;
  @Input() getUrl: string;
  @Input() postUrl: string;
  @Input() heading: string;
  @Input() stepDetails: any;
  payload: any
  sotrData: any;
  expandedSections={
    needGenFrom:false
  }
  needData:any[]=[]
  toggleSection(val){
    this.expandedSections[val] = !this.expandedSections[val];
  }
constructor(private route: ActivatedRoute,private api: ApiService, private uploadService: UploadService, private messageService: MessageService) {}
  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      const step_id = params['step'];
      this.payload = {
        proposal_id: proposalId,
        proposal_step: step_id,
        proposal_name: proposalName,
      };
    });
    if (this.payload.proposal_step) {
      this.getdata();
    }
  }

  getdata(){
    this.api.getAPI(`${this.getUrl}?proposal_step=${this.payload.proposal_step}&proposal_step__proposal=${this.payload.proposal_id}`).subscribe({
      next: (res: any) => {
        console.log('sotr data',res);
        this.needData = res.need_generation[0];
        this.sotrData = res.sotr_data;
        this.remark = this.sotrData[0]?.sotr;
      },
      error: (err) => {
        console.log('error',err);
      }
    });
  }
  



remark='';
  onSubmit(){
    if(this.sotrData.length > 0){
      this.api.putAPI(this.postUrl+this.sotrData[0].id+'/', {
        sotr: this.remark || '',
      }).subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail:res.message || 'Form submitted successfully',
          });
          this.getdata()
        }
      });
    }else{
      this.api.postAPI(this.postUrl, {
        proposal_step: this.payload.proposal_step,
        sotr: this.remark || '',
      }).subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail:res.message || 'Form submitted successfully',
          });
          this.getdata()
        },
      });
    }
  }
}




